import ContactSearch from '../Contact-Search/Contact-Search';
import classes from './MainContactSearch.module.css';
import PUBLIC from '../../PUBLIC';

const MainContactSearch = ({bgColor,
                            insideColors,
                            size,
                            searchBarClass,
                            cStyles,
                            dropdowns=[],
                            collapsedState=false,
                            cartIconContainer="",
                            links=[]}) => {
	const headerBackground = bgColor;
    const headerInsideColors = insideColors;
    const iconWidth = size[0];
    const iconHeight = size[1];

    const searchCartIconStyles = {
        color: headerInsideColors,
        ':hover': {
            cursor: 'pointer'
        },
        width: iconWidth,
        height: iconHeight,
        zIndex: '3',
        position: 'absolute',
    };

    const iStyles = {
        color: headerInsideColors
    }

    const tStyles = {
        color: headerInsideColors
    }

    const containerStyles = {
        position: 'fixed',
        zIndex: '1000'
    }

    const searchFieldCss = searchBarClass;

    const {email, phoneNumber} = PUBLIC;

	return (
		<ContactSearch backgroundColor={headerBackground}
                       contactHeaderTextStyles={{...tStyles}}
                       iconWidth={iconWidth}
                       iconHeight={iconHeight}
                       searchCartIconStyles={searchCartIconStyles}
                       collapsedState={collapsedState}
                       dropdowns={dropdowns}
                       links={links}
                       containerStyles={{
                        position: 'fixed',
                        zIndex: '1000',
                        ...cStyles
                       }}
                       data={{
                         email,
                         whatsapp: phoneNumber,
                       }}
                       containerClass={`${cartIconContainer}
                        ${collapsedState ? classes.searchIcon : ''}`}
                       searchFieldStyles={searchFieldCss}
                       contactIconStyles={iStyles}/>
	);
};

export default MainContactSearch;
